import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container page-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#save" })
], -1)
const _hoisted_3 = {
  key: 1,
  class: "alert alert-error mt-0 mb-8",
  role: "alert",
  "aria-atomic": "true"
}
const _hoisted_4 = { class: "alert-body" }
const _hoisted_5 = { class: "alert-heading" }
const _hoisted_6 = { class: "alert-text nobullet-list" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "page-navigation" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormularFelt = _resolveComponent("FormularFelt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_router_link, {
        to: "/metadata",
        class: "back-link"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.tilbage' }, null, 8, ["tekstNoegle"])
        ]),
        _: 1
      }),
      (_ctx.canSaveDraft())
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveDraft())),
            id: "gemKladdeKnap",
            href: "javascript:void(0)",
            class: "function-link",
            style: {"float":"right"}
          }, [
            _hoisted_2,
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.knap.gem-kladde' }, null, 8, ["tekstNoegle"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.hentFejl(_ctx.nuvaerendeTrin).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.alert' }, null, 8, ["tekstNoegle"])
              ]),
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hentFejl(), (fejl) => {
                  return (_openBlock(), _createElementBlock("li", { key: fejl }, [
                    _createElementVNode("a", {
                      class: "function-link",
                      href: '#' + fejl.tcoElementName?.replaceAll(':', '-').replaceAll('.', '_').replaceAll('[', '--').replaceAll(']', '').replaceAll('@', '_at_')
                    }, _toDisplayString(fejl.fejlbesked), 9, _hoisted_7)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.metadataDocument === null)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_8, [
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.detalje.overskrift1' }, null, 8, ["tekstNoegle"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.metadataDocument !== null)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_9, [
            _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.detalje.overskrift2' }, null, 8, ["tekstNoegle"])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (felt) => {
        return (_openBlock(), _createBlock(_component_FormularFelt, {
          key: felt,
          felt: felt,
          maerkat: felt.maerkat,
          validators: _ctx.feltValidators.get(felt.tcoElementName),
          readOnly: _ctx.isFeltDisabled(felt)
        }, null, 8, ["felt", "maerkat", "validators", "readOnly"]))
      }), 128)),
      (_ctx.showSpecification)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("h4", null, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.item-specifikation' }, null, 8, ["tekstNoegle"])
            ]),
            _hoisted_11,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemSpecificationsFields, (field) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "form-group",
                key: field
              }, [
                (field.felttype != _ctx.FeltType.HIDDEN)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_FormularFelt, {
                        readOnly: field.readOnly || _ctx.isFeltDisabled(field),
                        maerkat: field.maerkat,
                        felt: field,
                        validators: _ctx.feltValidators.get(_ctx.getFieldValidatorName(field.tcoElementName))
                      }, null, 8, ["readOnly", "maerkat", "felt", "validators"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("a", {
                class: "button button-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.send())),
                id: "gem-button",
                disabled: _ctx.submitting
              }, [
                _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.gem' }, null, 8, ["tekstNoegle"])
              ], 8, _hoisted_15)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}